/*
 * @Descripttion: 游戏banner主图
 * @Author: huangfuchunmei
 * @Date: 2023-08-28 11:09:40
 * @LastEditors: caiqin.xie
 * @LastEditTime: 2023-09-19 18:00:39
 */
import React from "react";
import styles from "./index.module.scss";
import LazyMedia from "@/components/LazyMedia";
import { IBanner } from "@/common/types";

interface ProductProps {
  ctry?: string;
  words: Record<string, string>;
  devGameList: IBanner[]; // 首页banner3数据
  device: string;
}
const DevGame: React.FC<ProductProps> = ({ words, devGameList, device }) => {
  const devGame: IBanner = devGameList[0] || null;
  const newDevice: string =
    device === "" ? "pc" : device === "paid" ? "pad" : device;
  return (
    <>
      {devGameList && (
        <div className={styles["game-wrap"]}>
          <div className={styles["game-img"]}>
            {devGame &&
              (devGame[newDevice].extension === ".mp4" ? (
                <LazyMedia
                  type="video"
                  loop
                  autoPlay
                  preload="auto"
                  playsInline
                  muted
                  src={devGame[newDevice]?.url}
                ></LazyMedia>
              ) : (
                <LazyMedia
                  type="image"
                  src={devGame[newDevice]?.url}
                  alt={devGame[newDevice]?.alt}
                />
              ))}
          </div>
          <div className={styles["game-content-wrap"]}>
            {devGame?.isShowTitle === 1 && (
              <h2>{devGame?.name}</h2>
            )}
            <h4 className="preLine">{devGame?.remark}</h4>
            {devGame && devGame.url && (
              <p className={styles["btn-group"]}>
                <span
                  className={styles["learn-more"]}
                  onClick={() => {
                    window.open(devGame.url);
                  }}
                >
                  {words?.common_learn_more}
                </span>
              </p>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default DevGame;
